import DOMPurify from 'dompurify';

export type DocxWorkerResponse =
  | { type: 'success'; html: string; warningCount: number }
  | { type: 'error' };

export function sanitizeDocxHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'code', 'pre', 'blockquote',
      'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'sup', 'sub',
    ],
    ALLOWED_ATTR: ['href', 'title', 'colspan', 'rowspan'],
  });
  return clean.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
}
